import { render } from "./ParticipantItem.vue?vue&type=template&id=90333d6c&ts=true"
import script from "./ParticipantItem.vue?vue&type=script&lang=ts"
export * from "./ParticipantItem.vue?vue&type=script&lang=ts"

import "./ParticipantItem.vue?vue&type=style&index=0&id=90333d6c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__